module.exports = __webpack_public_path__ + "img/doc-placeholder.8835b540.jpg";